export const caseStudies = [
  {
    industry: "Luxury Auto Dealer",
    context: "Pacific Northwest · 90-day geofence + retargeting",
    headline: "0.42%",
    headlineLabel: "click-through rate — 2.6× the display average",
    stats: [
      { label: "Impressions Served", value: "2,060,000" },
      { label: "Competitor Lots Fenced", value: "8" },
      { label: "Showroom Visit Lift", value: "+38%" },
    ],
  },
  {
    industry: "Medical Aesthetics",
    context: "Multi-location med spa · conquest campaign",
    headline: "3.4×",
    headlineLabel: "return on ad spend from fenced audiences",
    stats: [
      { label: "Impressions Served", value: "1,375,000" },
      { label: "Competitor Venues Fenced", value: "6" },
      { label: "Booked Consults (90 days)", value: "112" },
    ],
  },
  {
    industry: "Boutique Fitness",
    context: "Event geofencing · new-member push",
    headline: "61",
    headlineLabel: "new memberships attributed in 90 days",
    stats: [
      { label: "Impressions Served", value: "945,000" },
      { label: "Events Captured", value: "4" },
      { label: "Cost Per New Member", value: "$41" },
    ],
  },
];

export const verticalPlaybooks = [
  {
    id: "politics",
    kicker: "Political Campaigns",
    title: "WIN THE DISTRICT.",
    desc: "Rallies, town halls, county fairs, debate watch parties — we fence the venues where voters physically show up, then keep your candidate's message in front of them through election day. District-level precision means zero wasted spend outside the voter base you need.",
    tactics: [
      "Fence rally venues, town halls and community events — yours and your opponent's",
      "Layer voter-district boundaries so ads only serve inside the electorate",
      "Sequential creative: introduce → persuade → get-out-the-vote countdown",
      "Full political-ad disclosure compliance handled end to end",
    ],
    stats: [
      { label: "Impressions Across 3 Districts", value: "1.2M" },
      { label: "Persuasion Display CTR", value: "0.38%" },
      { label: "Days To Launch", value: "5" },
    ],
  },
  {
    id: "casinos",
    kicker: "Casinos & Gaming",
    title: "CAPTURE THE PLAYER.",
    desc: "Players who walked a competitor's floor last weekend are the most valuable audience in gaming. We capture devices at competing casinos, resorts and entertainment venues, then re-engage them with your offers, events and player's-club perks.",
    tactics: [
      "Fence competitor casino floors, hotels and concert venues",
      "Dwell-time filters isolate real players from pass-through traffic",
      "Re-engage lapsed visitors of your own property with win-back offers",
      "Sensitive-category screening and responsible-gaming compliance built in",
    ],
    stats: [
      { label: "Player's-Club Signup Lift", value: "+22%" },
      { label: "ROAS On Comp Offers", value: "4.1×" },
      { label: "Retargeting Window", value: "60 days" },
    ],
  },
  {
    id: "sports",
    kicker: "Sports & Stadiums",
    title: "OWN GAME DAY.",
    desc: "World Cup watch zones, baseball home stands, basketball arenas — a stadium is tens of thousands of hyper-engaged fans in one fence. On June 19 we fenced Lumen Field in Seattle: 66,925 people entered, and we served each one an average of 7 impressions after they left — merch, ticket packages, sports-bar promos and sponsor activations long after the final whistle.",
    tactics: [
      "Fence stadiums and arenas on game day — down to entry gates and parking lots",
      "World Cup, MLB and NBA event calendars mapped to fence schedules",
      "Retarget fans with merch drops, season-ticket offers and venue promos",
      "Conversion zones measure who showed up to your bar, store or box office",
    ],
    stats: [
      { label: "People Entered · Lumen Field, June 19", value: "66,925" },
      { label: "Impressions Served", value: "468,475" },
      { label: "Impressions Per Person", value: "7" },
    ],
  },
  {
    id: "retail",
    kicker: "Retail & Holiday Promos",
    title: "STEAL THE SEASON.",
    desc: "From Black Friday through New Year, shoppers are physically moving between malls and competitor stores. We fence them in motion and serve countdown offers that pull them through your doors instead — with foot-traffic attribution proving every visit.",
    tactics: [
      "Fence malls, shopping districts and competitor storefronts through the holidays",
      "Countdown creative sequenced to Black Friday, Cyber Week and last-minute gifting",
      "Household-income and demographic layers for premium product lines",
      "Conversion-zone reporting ties ad spend directly to store visits",
    ],
    stats: [
      { label: "Holiday Foot-Traffic Lift", value: "+31%" },
      { label: "Cost Per Attributed Visit", value: "$38" },
      { label: "Peak-Season Impressions", value: "640,000" },
    ],
  },
];
